import script from "./CardsList.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsList.vue?vue&type=script&setup=true&lang=js"

import "./CardsList.vue?vue&type=style&index=0&id=22457276&lang=scss"

const __exports__ = script;

export default __exports__